var ShippingTimelineCalculator = {
  estimate: function (items, min, max, vendor, carrier, forceWeeks) {
    min = parseInt(min)
    max = parseInt(max)
    var lastMile = false
    var totalWeight = items
      .map(function (x) {
        return x.weight * x.quantity
      })
      .reduce(function (accumulator, currentValue) {
        return accumulator + currentValue
      })

    if (vendor == 'XPO') {
      // console.log('totalWeight', totalWeight)

      if (totalWeight >= 100) {
        // Last Mile
        lastMile = true

        var parcelItems = items.filter(function (x) {
          return x.weight < 100 && x.timeline && x.timeline.max
        })

        //console.log('parcelItems', parcelItems)

        if (parcelItems.length > 0) {
          var maxTimelineParcel = parcelItems.sort(function (a, b) {
            return parseInt(b.timeline.max) - parseInt(a.timeline.max)
          })[0].timeline

          if (parseInt(maxTimelineParcel.max) == max) {
            // add 2-4 weeks
            min = parseInt(maxTimelineParcel.min) + 14
            max = parseInt(maxTimelineParcel.max) + 28
          }
        }
      }
    } else {
      if (vendor == 'LZB' && totalWeight >= 100) {
        lastMile = true
      }
    }

    // console.log('minmax', min, max)

    var displayTimes = this.segmentTimings(min, max, forceWeeks)

    return {
      min: displayTimes.min,
      max: displayTimes.max,
      timeUnit: displayTimes.timeUnit,
      carrier: carrier,
      lastMile: lastMile,
    }
  },

  segmentTimings: function (min, max, forceWeeks) {
    var n = min
    var x = max
    var u = 'days'
    if (forceWeeks) {
      if (min > 7) {
        // only convert to weeks if the min time is at least one week
        n = Math.ceil(min / 7)
        x = Math.ceil(max / 7)
        u = 'weeks'
      }
    } else {
      if (min % 7 == 0 && max % 7 == 0) {
        n = min / 7
        x = max / 7
        u = 'weeks'
      }
    }
    return {
      min: n,
      max: x,
      timeUnit: u,
    }
  },
}
